module.exports = __webpack_public_path__ + "img/coming-soon.1161dd61.png";